const CORRELATION_WINDOW_MS = 2000;

let currentCorrelationId: string | null = null;
let lastIssuedAt = 0;

function generateUuidFallback(): string {
  const bytes = new Uint8Array(16);

  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
}

function createCorrelationId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return generateUuidFallback();
}

export function getCurrentCorrelationId(now: number = Date.now()): string {
  const shouldRotate = !currentCorrelationId || now - lastIssuedAt > CORRELATION_WINDOW_MS;

  if (shouldRotate) {
    currentCorrelationId = createCorrelationId();
  }

  lastIssuedAt = now;
  return currentCorrelationId!;
}
